import { render, staticRenderFns } from "./AffiliateList.vue?vue&type=template&id=f40899ee"
import script from "./AffiliateList.vue?vue&type=script&lang=ts"
export * from "./AffiliateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports